import {
  GET_SIGNATURE_SUCCESS,
  FETCH_SIGNER_DATA,
  FETCH_SIGNER_DATA_SUCCESS,
  FETCH_SIGNER_DATA_FAILURE,
  UPLOAD_SIGNATURE_FILE,
  CREATE_SIGNATURE,
  CREATE_SIGNATURE_SUCCESS,
  CREATE_SIGNATURE_FAILURE,
  GET_SIGNATURE_FAILURE,
  CLOSE_SIGNATURE_MODAL,
  OPEN_SIGNATURE_MODAL,
  UPDATE_SIGNATURE
} from '../actions/actionTypes';

const initialState = {
  signedDoc: [],
  signerData: null,
  loading: false,
  error: null,
  open: false
};

const signatureReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_SIGNER_DATA:
      return { 
        ...state,
        loading:true,
        error: null 
      };
      
    case FETCH_SIGNER_DATA_SUCCESS:
      return { 
        ...state, 
        signerData: action.payload, 
        loading: false 
      };
      
    case FETCH_SIGNER_DATA_FAILURE:
      return { 
        ...state, 
        error: action.payload, 
        loading: false 
      };
      
    case GET_SIGNATURE_SUCCESS:
      return { 
        ...state, 
        signedDoc: action.signedDoc 
      };

      case GET_SIGNATURE_FAILURE:
      return { 
        ...state, 
        signedDoc:  []
      };
      case CREATE_SIGNATURE:
      return { 
        ...state, 
        loading: true 
      };
      case CREATE_SIGNATURE_SUCCESS:
      return { 
        ...state, 
        loading: false 
      };
      case CREATE_SIGNATURE_FAILURE:
        return { 
          ...state, 
          loading: false 
        };
     case UPLOAD_SIGNATURE_FILE: {
      return { 
        ...state, 
        loading: false 
      };
     }
     case OPEN_SIGNATURE_MODAL:
      return {
        ...state,
        open: true,
      };
     case CLOSE_SIGNATURE_MODAL:
      return {
        ...state,
        open: false,
      };
      case UPDATE_SIGNATURE:
        return {
          ...state,
          loading:true,
        };
    default:
      return state;
  }
};

export default signatureReducer;
